import { render, staticRenderFns } from "./HomeAutomationSection.vue?vue&type=template&id=6063fe24&scoped=true&"
import script from "./HomeAutomationSection.vue?vue&type=script&lang=js&"
export * from "./HomeAutomationSection.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentModule.css?vue&type=style&index=0&id=6063fe24&scoped=true&lang=css&"
import style1 from "../../sass/components/continue-section.css?vue&type=style&index=1&id=6063fe24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6063fe24",
  null
  
)

export default component.exports